export default __webpack_public_path__ + "static/media/Walmart.bfff9062.svg";